<script lang="ts">
    import TemplateIcon from './TemplateIcon.svelte';
    // import src from '../../../assets/filter_alt_FILL0_wght400_GRAD0_opsz24.svg';
    // import src from '../../../assets/automapa_filter.svg';
    // import src from '../../../assets/tune_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
    import src from './svg/official/FilterS.svg';

    export let scale: number = 1;
</script>

<TemplateIcon {src} alt="Filtr" scale={scale * 0.7} on:click />
